import { sortBy } from 'lodash';

export const webSafeFontsNames = [
    'Georgia',
    'Palatino Linotype',
    'Book Antiqua',
    'Palatino',
    'Times New Roman',
    'Times',
    'serif',
    'Arial',
    'Helvetica',
    'Arial Black',
    'Gadget',
    'Comic Sans MS',
    'cursive',
    'Impact',
    'Charcoal',
    'Lucida Sans Unicode',
    'Lucida Grande',
    'Tahoma',
    'Geneva',
    'Trebuchet MS',
    'Helvetica',
    'Verdana',
    'Geneva',
    'sans-serif',
    'Courier New',
    'Courier',
    'Lucida Console',
    'Monaco',
    'monospace'
].sort();
export const webSafeFonts = webSafeFontsNames.map(font => ({ key: font, label: font }));

export const fontWeights = ['Lighter', 'Normal', 'Bold', 'Bolder'];

export const fontWeight = [100, 200, 300, 400, 500, 600, 700, 800, 900];

export const availableFontSizes = [
    '0px',
    '1px',
    '2px',
    '3px',
    '4px',
    '5px',
    '6px',
    '7px',
    '8px',
    '9px',
    '10px',
    '11px',
    '12px',
    '13px',
    '14px',
    '15px',
    '16px',
    '17px',
    '18px',
    '19px',
    '20px',
    '21px',
    '22px',
    '23px',
    '24px',
    '25px',
    '26px',
    '27px',
    '28px',
    '29px',
    '30px',
    '31px',
    '32px',
    '33px',
    '34px',
    '35px',
    '36px',
    '37px',
    '38px',
    '39px',
    '40px',
    '50px',
    '60px',
    '70px',
    '72px'
];

export const availableFontStyle = ['normal', 'italic'];

export const availableFontWeight = ['normal', 'bold'];

export const availableTextDecoration = ['none', 'underline'];

export const availableLineHeight = ['1.0', '1.15', '1.25', '1.5', '2.0', '2.5', '3.0', '3.75'];

export const availableTextAlign = ['left', 'right', 'center'];

export const availableBorderStyle = ['solid', 'none', 'double', 'groove', 'ridge', 'inset', 'outset'];

export const availableBorderRadius = [
    '0px',
    '1px',
    '2px',
    '3px',
    '4px',
    '5px',
    '6px',
    '7px',
    '8px',
    '9px',
    '10px',
    '11px',
    '12px',
    '13px',
    '14px',
    '15px',
    '16px',
    '17px',
    '18px',
    '19px',
    '20px',
    '25px',
    '30px'
];

export const availableBorderWidth = ['1px', '2px', '3px', '4px', '5px'];

export const availableTextTransform = ['uppercase', 'lowercase', 'capitalize', 'none'];

export const imageHeight = ['50px', '100px', '150px', '200px', '250px', '300px', '350px', '400px', '425px', '450px'];



// WEBPACK FOOTER //
// ./src/constants/availableFonts.js